import React, { useEffect, useRef } from "react";
import confetti from "canvas-confetti";

export default function Confetti({
	originRef = null,
	origin = { y: 1.2 },
	spread = 70,
	angle = 90,
	startVelocity = 20,
	particleCount = 100,
}) {
	const canvasRef = useRef(null);

	useEffect(() => {
		const emoji = confetti.shapeFromText({text: '🍔', scalar: 2})

		const myConfetti = confetti.create(canvasRef.current, {
			resize: true,
			useWorker: true,
		});

		let computedOrigin = origin;
		if (originRef?.current) {
			const rect = originRef.current.getBoundingClientRect();
			computedOrigin = {
				x: (rect.left + rect.width / 2) / window.innerWidth,
				y: (rect.top + rect.height / 2) / window.innerHeight,
			};
		}

		myConfetti({
			particleCount,
			spread,
			angle,
			origin: computedOrigin,
			ticks: 150,
			gravity: 0,
			decay: 0.96,
			scalar: 2,
			startVelocity,
			shapes: [emoji]
		});

	}, []);
	
	return (
		<canvas
			ref={canvasRef}
			style={{
				position: "fixed",
				pointerEvents: "none",
				width: "100%",
				height: "100%",
				top: 0,
				left: 0,
				zIndex: 9999,
			}}
		/>
	);
}
